import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUserCircle} from "@fortawesome/free-solid-svg-icons";

import "./profile-picture.scss";

export interface ProfilePictureProps {
  userDisplayName?: string;
  className?: string;
}

function ProfilePicture(props: ProfilePictureProps) {
  const {
    userDisplayName,
    className,
  }  = props;
  return <span className={"Profile-picture" + (className ? " " + className : "")} title={userDisplayName || "?"}>
    <FontAwesomeIcon icon={faUserCircle} className={"icon"} />
  </span>;
}
export default ProfilePicture;
